import { atom } from 'jotai';


const relationshipTypesAtom = atom([]);

export { relationshipTypesAtom };